import {
  GET_METADATA,
  SET_PRODUCT_ID,
} from "../../shared/constants/ActionTypes";

const initalMetaData = {
  eh_metaData: [],
};

const metaDataReducer = (state = initalMetaData, action) => {
  switch (action.type) {
    case GET_METADATA:
      return {
        ...state,
        eh_metaData: action.payload.metaData,
      };
    case SET_PRODUCT_ID:
      return {
        ...state,
        courseId: action.payload,
      };

    default:
      return state;
  }
};

export default metaDataReducer;
